const initialState = {
  isAuthenticated: false,
  userData: {},
  registeredMail: "",
  isLoadingAuth: false,
  isLoadingReg: false,
  isLoading: false,
  isForgotPassword: false,
  otp: null,
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case "LOADER_START_AUTH":
      return {
        ...state,
        isLoadingAuth: true,
      };
    case "LOADER_STOP_AUTH":
      return {
        ...state,
        isLoadingAuth: false,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        userData: action.payload,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        isAuthenticated: false,
        userData: [],
      };
    case "SIGN_UP_PENDING":
      return {
        ...state,
        isLoadingReg: true,
      };
    case "SIGN_UP_SUCCESS":
      return {
        ...state,
        registeredMail: action?.payload,
        isForgotPassword: false,
      };
    case "VERIFY_OTP_LOADING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Verifying OTP",
      };
    case "VERIFY_OTP_SUCCESS":
      return {
        ...state,
        isLoading: false,
        isForgotPassword: false,
        otp: action?.payload,
        statusMessage: "",
      };
    case "VERIFY_OTP_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: "",
      };
    case "UPDATE_PROFILE_INFO_LOADING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Updating profile data",
      };
    case "UPDATE_PROFILE_INFO_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "UPDATE_PROFILE_INFO_SUCCESS":
      return {
        ...state,
        isLoading: false,
        userData: {
          ...state.userData,
          ...action.payload,
        },
        statusMessage: null,
      };
    case "UPDATE_PASSWORD_LOADING":
      return {
        ...state,
        isLoading: true,
      };
    case "UPDATE_PASSWORD_ERROR":
      return {
        ...state,
        isLoading: false,
      };
    case "UPDATE_PASSWORD_SUCCESS":
      return {
        ...state,
        isLoading: false,
      };
    case "FORGOT_PASSWORD_PENDING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Sending OTP",
      };
    case "FORGOT_PASSWORD_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "FORGOT_PASSWORD_SUCCESS":
      return {
        ...state,
        isLoading: false,
        registeredMail: action?.payload,
        isForgotPassword: true,
        statusMessage: null,
      };
    case "RESET_PASSWORD_LOADING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Updating Password",
      };
    case "RESET_PASSWORD_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "RESET_PASSWORD_SUCCESS":
      return {
        ...state,
        isLoading: false,
        registeredMail: "",
        isForgotPassword: false,
        statusMessage: null,
        otp: null,
      };
    case "RESEND_OTP_LOADING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Resending OTP",
      };
    case "RESEND_OTP_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "RESEND_OTP_SUCCESS":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "DELETE_PROFILE_LOADING":
      return {
        ...state,
        isLoading: true,
        statusMessage: "Deleting Profile",
      };
    case "DELETE_PROFILE_SUCCESS":
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        statusMessage: null,
        userData: [],
      };
    case "DELETE_PROFILE_ERROR":
      return {
        ...state,
        isLoading: false,
        statusMessage: null,
      };
    case "GET_MY_PERMISSIONS_SUCCESS":
      return {
        ...state,
        userData: {
          ...state.userData,
          permissions: action.payload,
        },
      };
    default:
      return state;
  }
};
